// extracted by mini-css-extract-plugin
export default {"topPattern":"pattern_topPattern__ab9Q7","bottomPattern":"pattern_bottomPattern__aOWtI"};